// extracted by mini-css-extract-plugin
export default {"BarChart":"BarChart_BarChart__n9dIj"};